<template>
  <div :class="[$style.wrapper]">
    <button v-if="!showPopup" :class="$style.helpButton" @click="$emit('open')">Нужна помощь?</button>
    <transition name="only-fade">
      <div v-if="showPopup" :class="$style.helpPopup">
        <div :class="$style.helpBox">
          <div v-if="showHeader" :class="$style.helpBox__header">
            <img v-if="type === 'warning'" src="@/assets/icons/warning.svg" :style="{ width: '3.7rem' }"/>
            <span>{{title}}</span>
          </div>
          <span :class="$style.helpBox__description" v-html="description"></span>
          <button :class="$style.helpBox__button"  @click="buttonClick">{{buttonText}}</button>
        </div>
        <img :class="$style.character" src="@/assets/girl.png" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'helpBox',
  props: {
    type: String,
    description: String,
    show: Boolean,
    warnMessage: String,
  },
  computed: {
    showHeader() {
      return this.type === 'task' || this.type === 'warning'
    },
    title() {
      return this.type === 'warning' ? 'Ошибка!' : 'Задание'
    },
    buttonText() {
      if (this.type === 'warning') {
        return 'Исправить'
      } if (this.type === 'task') {
        return 'ОК'
      }
      return 'Продолжить'
    },
  },
  watch: {
    show() {
      this.showPopup = this.show
    },
  },
  data: () => ({
    showPopup: false,
  }),
  methods: {
    buttonClick() {
      this.$emit('close')
      if (this.type === 'warning') {
        this.$emit('closeWarning')
      }
    },
    closeWarning() {
      if (!this.showPopup) return
      this.$emit('close')
      this.$emit('closeWarning')
    },
  },
}
</script>
<style lang="scss" module>
  @import './helpBox.scss';
</style>
